export default {
  '& .oc-locked-content': {
    background: 'none',
    display: 'block',
    position: 'relative',
    aspectRatio: 16 / 9,
    height: '100%',
    marginBottom: '3rem',

    '&__lock-icon': {
      zIndex: 100,
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
    },
  },
};
